export default {
    equipes: state => state.lista
}